import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { Row, Col, Modal, Button } from 'react-bootstrap'

import LoadingScreen from '../../components/LoadingScreen'

import './style.css'

import LoginForm from './components/LoginForm'
import { checkAPIAccess } from "./reducers/loginReducer"
import { getServerUrl } from "../../functions/getServerUrl"

const LoginContainer = (props) => {
  useEffect(() => {
    props.checkAPIAccess()
    // eslint-disable-next-line
  }, [])

  const routerPropsState = props.routerProps.history.location.state
  if (props.authenticatingUser) {
    return <LoadingScreen text="Authenticating User" />
  } else if (!localStorage.getItem('jwt') || !props.loggedIn) {
    return (
      <div id='LoginContainer'>
        <Modal size="lg" show={ !props.apiAccess } onHide={ () => null }>
          <Modal.Header><Modal.Title>API Access Error</Modal.Title></Modal.Header>
          <Modal.Body>
            <p className="contact-modal-text">
              We are having trouble accessing a component of the system. <br/><br/>
              To troubleshoot, please try to access the following link directly: <br/><a href={getServerUrl()}>{getServerUrl()}/</a><br/><br/>
              If the page loads and you see red text stating "Authentication credentials were not provided."
              somewhere on the page, please contact <a href="mailto:support@genesisrg.com">support@genesisrg.com</a>.<br/><br/>
              If the page does not load or a page loads that does not include the above red text,
              then the API may be getting blocked by your institution's security settings.
              If this is the case, please contact your institution's IT department
              to request that the above link be unblocked.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => window.location.reload()}>
              Retry
            </Button>
          </Modal.Footer>
        </Modal>
        <Row>
          <Col xs={12} sm={12} md={8} lg={6}>
            <LoginForm />
          </Col>
        </Row>
      </div>
    )
  } else if (props.prevLocation) {
    return <Redirect to={props.prevLocation} />
  } else {
    if (routerPropsState) {
      return <Redirect to={routerPropsState.referrer} />
    }
    return <Redirect to='/' />
  }
}

const mapStateToProps = (state) => {
  return {
    loggedIn: state.loginReducer.loggedIn,
    authenticatingUser: state.loginReducer.authenticatingUser,
    prevLocation: state.loginReducer.prevLocation,
    apiAccess: state.loginReducer.apiAccess,
  }
}

export default connect(mapStateToProps, { checkAPIAccess })(LoginContainer)
